module.exports = __webpack_public_path__ + "img/bck.9e5b7388.svg";